// Voucher lists (Cash / Bank Payment, Cash / Bank Receipt): From / To date
// filter in the list toolbar. Both empty = no date limit (the list as before).
// Firebase cost: like the search box — the active year's vouchers are loaded
// once when a filter is set, then filtered on screen.
import React from 'react';
import { StatusFilterSelect } from './SharedStyles';
import { localDateStr } from '../utils/localDate';

const ymd = (v) => {
  if (!v) return '';
  if (typeof v === 'string') return v.slice(0, 10);
  if (typeof v.toDate === 'function') return localDateStr(v.toDate());
  if (v instanceof Date) return localDateStr(v);
  return '';
};

/** Is a document date inside From..To (both inclusive; empty = open)? */
export const inDateRange = (docDate, from, to) => {
  if (!from && !to) return true;
  const d = ymd(docDate);
  if (!d) return false;
  if (from && d < from) return false;
  if (to && d > to) return false;
  return true;
};

const ListDateRange = ({ from, to, onChange }) => (
  <>
    <StatusFilterSelect
      as="input" type="date" aria-label="From date" title="From date"
      value={from} max={to || undefined}
      onChange={(e) => onChange(e.target.value, to)}
    />
    <StatusFilterSelect
      as="input" type="date" aria-label="To date" title="To date"
      value={to} min={from || undefined}
      onChange={(e) => onChange(from, e.target.value)}
    />
  </>
);

export default ListDateRange;
